/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/uk_UA';
const locale = {
  "accessibility_checker_b3af1f6c": {
    "message": "Перевірка доступності"
  },
  "add_8523c19b": {
    "message": "Додати"
  },
  "add_one_9e34a6f8": {
    "message": "Додати одного!"
  },
  "align_11050992": {
    "message": "Вирівняти"
  },
  "all_4321c3a1": {
    "message": "Всі"
  },
  "alpha_15d59033": {
    "message": "Альфа"
  },
  "alphabetical_55b5b4e0": {
    "message": "Алфавітний"
  },
  "alt_text_611fb322": {
    "message": "Альтернативний текст"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Сталася помилка при виконанні запиту мережі"
  },
  "announcement_fb4cb645": {
    "message": "Оголошення"
  },
  "announcement_list_da155734": {
    "message": "Список оголошень"
  },
  "announcements_a4b8ed4a": {
    "message": "Оголошення"
  },
  "apply_781a2546": {
    "message": "Застосувати"
  },
  "apps_54d24a47": {
    "message": "Застосунки"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Ви впевнені, що хочете скасувати? Зроблені зміни можуть бути не збережені."
  },
  "arrows_464a3e54": {
    "message": "Стрілки"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Співвідношення сторін збережеться"
  },
  "assignment_976578a8": {
    "message": "Завдання"
  },
  "assignments_1e02582c": {
    "message": "Завдання"
  },
  "attributes_963ba262": {
    "message": "Атрибути"
  },
  "basic_554cdc0a": {
    "message": "Базовий"
  },
  "blue_daf8fea9": {
    "message": "Синій"
  },
  "bottom_15a2a9be": {
    "message": "Низ"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Скасувати"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Зроблені Вами зміни можуть бути не збережені."
  },
  "characters_9d897d1c": {
    "message": "Символи"
  },
  "choose_usage_rights_33683854": {
    "message": "Виберіть права використання..."
  },
  "clear_2084585f": {
    "message": "Очистити"
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Натисніть на вбудоване { imageName }"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Натисніть, щоб вставити  посилання на редактор."
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Закрийте меню або діалогове вікно. Що також повертає вас до області редактора"
  },
  "close_d634289d": {
    "message": "Закрити"
  },
  "collaborations_5c56c15f": {
    "message": "Сумісна робота"
  },
  "color_a363e1b0": {
    "message": "Колір"
  },
  "computer_1d7dfa6f": {
    "message": "Комп''ютер"
  },
  "content_1440204b": {
    "message": "Вміст"
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Вміст все ще завантажується, якщо ви продовжите, він не буде вбудований належним чином."
  },
  "content_type_2cf90d95": {
    "message": "Тип вмісту"
  },
  "copyright_holder_66ee111": {
    "message": "Правовласник:"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {}\n    few {}\n   many {}\n  other {}\n}"
  },
  "course_files_62deb8f8": {
    "message": "Файли курсу"
  },
  "course_files_a31f97fc": {
    "message": "Файли курсу"
  },
  "course_navigation_dd035109": {
    "message": "Навігація курсу"
  },
  "creative_commons_license_725584ae": {
    "message": "Ліцензія Creative Commons:"
  },
  "custom_6979cd81": {
    "message": "Звичай"
  },
  "cyan_c1d5f68a": {
    "message": "Зелено-синій колір"
  },
  "decorative_image_fde98579": {
    "message": "Декоративне зображення"
  },
  "decrease_indent_d9cf469d": {
    "message": "Зменшити відступ"
  },
  "deep_purple_bb3e2907": {
    "message": "Темно-фіолетовий"
  },
  "default_9db103d": {
    "message": "За замовчуванням"
  },
  "delimiters_4db4840d": {
    "message": "Розділювачі"
  },
  "description_436c48d7": {
    "message": "Опис"
  },
  "details_98a31b68": {
    "message": "Подробиці"
  },
  "discussion_6719c51d": {
    "message": "Обговорення"
  },
  "discussions_a5f96392": {
    "message": "Обговорення"
  },
  "discussions_index_6c36ced": {
    "message": "Індекс обговорення"
  },
  "documents_81393201": {
    "message": "Документи"
  },
  "done_54e3d4b6": {
    "message": "Готово"
  },
  "down_5831a426": {
    "message": "Вниз"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Перетягніть файл сюди"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Перетягніть і відпустіть, або клацніть для перегляду вашого комп''ютера"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Очікується: Кілька дат"
  },
  "edit_c5fbea07": {
    "message": "Редагувати"
  },
  "embed_image_1080badc": {
    "message": "Вставити забраження"
  },
  "external_tools_6e77821": {
    "message": "Зовнішні інструменти"
  },
  "files_c300e900": {
    "message": "Файли"
  },
  "files_index_af7c662b": {
    "message": "Індекс файлів"
  },
  "find_8d605019": {
    "message": "Знайти"
  },
  "format_4247a9c5": {
    "message": "Формат"
  },
  "generating_preview_45b53be0": {
    "message": "Генерується попередній перегляд..."
  },
  "grades_a61eba0a": {
    "message": "Оцінки"
  },
  "greek_65c5b3f7": {
    "message": "Грецький"
  },
  "green_15af4778": {
    "message": "Зелений"
  },
  "group_files_82e5dcdb": {
    "message": "Файли групи"
  },
  "group_navigation_99f191a": {
    "message": "Навігація групи"
  },
  "home_351838cd": {
    "message": "На домашню сторінку"
  },
  "html_editor_fb2ab713": {
    "message": "HTML-редактор"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Я отримав дозвіл на використання цього файлу."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Я володію авторським правом"
  },
  "icon_215a1dc6": {
    "message": "Піктограма"
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Якщо ви не виберете права використання, цей файл не буде опублікований після його завантаження."
  },
  "image_8ad06": {
    "message": "Зображення"
  },
  "images_7ce26570": {
    "message": "Зображення"
  },
  "increase_indent_6af90f7c": {
    "message": "Збільшити відступ"
  },
  "indigo_2035fc55": {
    "message": "Індиго"
  },
  "insert_593145ef": {
    "message": "Вставка"
  },
  "insert_link_6dc23cae": {
    "message": "Вставити посилання"
  },
  "insert_math_equation_57c6e767": {
    "message": "Вставити математичну формулу"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Недійсний тип файлу"
  },
  "invalid_url_cbde79f": {
    "message": "Невірний URL"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Гарячі клавіши"
  },
  "light_blue_5374f600": {
    "message": "Світло-блакитний"
  },
  "link_7262adec": {
    "message": "Посилання"
  },
  "links_14b70841": {
    "message": "Посилання"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Посилання на зовнішній сайт."
  },
  "loading_25990131": {
    "message": "Завантаження..."
  },
  "loading_bde52856": {
    "message": "Завантаження"
  },
  "loading_failed_b3524381": {
    "message": "Невдале завантаження..."
  },
  "locked_762f138b": {
    "message": "Заблоковано"
  },
  "media_af190855": {
    "message": "Носій інформації"
  },
  "minimize_file_preview_da911944": {
    "message": "Згорнути попередній перегляд файлу"
  },
  "minimize_video_20aa554b": {
    "message": "Зменшити відео"
  },
  "misc_3b692ea7": {
    "message": "Різне"
  },
  "module_90d9fd32": {
    "message": "Розділ"
  },
  "modules_c4325335": {
    "message": "Розділи"
  },
  "my_files_2f621040": {
    "message": "Мої файли"
  },
  "name_1aed4a1b": {
    "message": "Ім''я"
  },
  "navigation_ee9af92d": {
    "message": "Навігація"
  },
  "new_quiz_34aacba6": {
    "message": "Нова контрольна робота"
  },
  "next_40e12421": {
    "message": "Далі"
  },
  "no_e16d9132": {
    "message": "Ні"
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Немає створених сторінок."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Попередній перегляд  для цього файлу недоступний."
  },
  "no_results_940393cf": {
    "message": "Результати відсутні."
  },
  "no_results_found_58717065": {
    "message": "Результатів не знайдено"
  },
  "none_3b5e34d2": {
    "message": "Ніхто"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Вікрити діалогове вікно гарячих клавіш"
  },
  "operators_a2ef9a93": {
    "message": "Оператори"
  },
  "options_3ab0ea65": {
    "message": "Параметри"
  },
  "orange_81386a62": {
    "message": "Помаранчевий"
  },
  "page_50c4823d": {
    "message": "Сторінка"
  },
  "pages_e5414c2c": {
    "message": "Сторінки"
  },
  "people_b4ebb13c": {
    "message": "Люди"
  },
  "percentage_34ab7c2c": {
    "message": "Відсоток"
  },
  "pink_68ad45cb": {
    "message": "Рожевий"
  },
  "prev_f82cbc48": {
    "message": "Попередній"
  },
  "preview_53003fd2": {
    "message": "Попередній перегляд"
  },
  "previous_bd2ac015": {
    "message": "Попередній"
  },
  "published_c944a23d": {
    "message": "опубліковано"
  },
  "purple_7678a9fc": {
    "message": "Фіолетовий"
  },
  "quiz_e0dcce8f": {
    "message": "Контрольна робота"
  },
  "quizzes_7e598f57": {
    "message": "Контрольні Роботи"
  },
  "record_7c9448b": {
    "message": "Записати"
  },
  "record_upload_media_5fdce166": {
    "message": "Запис/завантаження медіа"
  },
  "recording_98da6bda": {
    "message": "Запис"
  },
  "red_8258edf3": {
    "message": "Червоний"
  },
  "relationships_6602af70": {
    "message": "Зв''язки"
  },
  "remove_f47dc62a": {
    "message": "Видалити"
  },
  "replace_e61834a7": {
    "message": "Замінити"
  },
  "reset_95a81614": {
    "message": "Скинути"
  },
  "rich_content_editor_2708ef21": {
    "message": "Редактор збагаченого контенту"
  },
  "save_11a80ec3": {
    "message": "Зберегти"
  },
  "search_280d00bd": {
    "message": "Пошук"
  },
  "selected_274ce24f": {
    "message": "Обраний"
  },
  "size_b30e1077": {
    "message": "Розмір"
  },
  "star_8d156e09": {
    "message": "Помітити зіркою"
  },
  "start_over_f7552aa9": {
    "message": "Почати з початку"
  },
  "submit_a3cc6859": {
    "message": "Підтвердити"
  },
  "submitting_b90fac62": {
    "message": "Надсилання..."
  },
  "syllabus_f191f65b": {
    "message": "Навчальний план"
  },
  "teal_f729a294": {
    "message": "Бірюзовий"
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Попередній перегляд документа в даний момент обробляється. Будь-ласка спробуйте пізніше."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Матеріал в публічному домені"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Матеріал опубліковано під ліцензією Creative Commons"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Цей документ не може бути показаний в Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Це рівняння не можна перетворити у базовому режимі перегляду"
  },
  "title_ee03d132": {
    "message": "Назва"
  },
  "top_66e0adb6": {
    "message": "Верх"
  },
  "unpublished_dfd8801": {
    "message": "Неопублікований"
  },
  "up_c553575d": {
    "message": "вверх"
  },
  "upload_media_ce31135a": {
    "message": "Завантажити медіа контент"
  },
  "uploading_19e8a4e7": {
    "message": "Завантаження"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Права використання:"
  },
  "video_player_b371005": {
    "message": "Відеопрогравач"
  },
  "view_ba339f93": {
    "message": "Вигляд"
  },
  "wiki_home_9cd54d0": {
    "message": "Домашня сторінка Wiki"
  },
  "yes_dde87d5": {
    "message": "Так"
  }
};
formatMessage.addLocale({
  'uk-UA': locale
});